"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICON_LABEL_POSITION = exports.ICON_LABEL_FONT_TYPE = void 0;
exports.ICON_LABEL_FONT_TYPE = {
    REGULAR: 'font-regular',
    LIGHT: 'font-light',
    THIN: 'font-thin',
    BOLD: 'font-bold',
    HAND: 'font-hand',
};
exports.ICON_LABEL_POSITION = {
    TOP: 'top',
    LEFT: 'left',
    RIGHT: 'right',
    BOTTOM: 'bottom',
};
//# sourceMappingURL=enums.js.map